export default "__VITE_ASSET__CVnanj8c__"